import yup from 'src/libs/yup';

export const VoucherStampStoreSchema = yup.object().shape({
  label: yup.string().required().label('Nome'),
  cnpj: yup.string().required().cpfCnpj().label('CNPJ'),
  file: yup.mixed().required().isFile().label('Imagem do carimbo'),
});

export const VoucherStampUpdateSchema = yup.object().shape({
  label: yup.string().required().label('Nome'),
  cnpj: yup.string().required().cpfCnpj().label('CNPJ'),
  file: yup.mixed().isFile().label('Imagem do carimbo'),
});
